exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n}\n\n.alert-loading {\n    color: white;\n}\n\n.alert-error {\n    font-weight: bold;\n    color: black;\n}", ""]);

// exports
